import { entityConfig, MutableEntityType } from 'app/agriculture/mutations/types/entityConfig';
import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ServicesContext } from 'app/items/shared/context_interface';
import { AxiosError } from 'axios';
import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { useEntityCacheInvalidation } from 'app/agriculture/mutations/useEntityCacheInvalidation';

/**
 * This mutation does not support entities with snapshots
 */
export function useEntityRemoveMutation(entityType: MutableEntityType) {
    const { agricultureToastService } = useContext(ServicesContext);
    const instance = createAxiosInstance();
    const config = entityConfig[entityType];
    const { removeFromCache } = useEntityCacheInvalidation(entityType);

    const { mutate, isPending } = useMutation<string, AxiosError<never, never>, string>({
        mutationFn: async function (id: string): Promise<string> {
            await instance.delete<never, never, never>(`${config.endpoint}${id}/`);
            return id;
        },
        onSuccess: function (id: string) {
            removeFromCache(id);
        },
        onError: async function (error) {
            console.error('Error deleting entity', error);
            await agricultureToastService.showToast({
                title: 'Delete Failed',
                subtext: 'Something went wrong',
                type: AgricultureToastType.ERROR,
                variant: 'simple',
            });
        },
    });

    return { mutate, isPending };
}
